import {reactive} from 'vue';
import axios from 'axios';

export function useAddressValidation(validationUrl) {
    const state = reactive({status: 'idle', recommendations: []});

    let controller = null;
    let confirmedSignature = null;

    function signature(address) {
        return [address.street, address.houseNumber, address.zip, address.city, address.countryCode].join('|');
    }

    async function validate(address) {
        if (!validationUrl || !address.street || !address.houseNumber || !address.zip || !address.city || !address.countryCode) {
            state.status = 'idle';

            return;
        }

        const currentSignature = signature(address);
        if (currentSignature === confirmedSignature) {
            state.status = 'valid';

            return;
        }

        if (controller) {
            controller.abort();
        }
        controller = new AbortController();
        state.status = 'checking';

        try {
            const response = await axios.get(validationUrl, {
                params: {street: address.street, number: address.houseNumber, zip: address.zip, city: address.city, countryCode: address.countryCode},
                signal: controller.signal,
                withCredentials: true
            });

            if (response.data.success) {
                confirmedSignature = currentSignature;
                state.status = 'valid';
                state.recommendations = [];
            } else {
                state.status = 'needs-review';
                state.recommendations = response.data.recommendations || [];
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                return;
            }
            console.error('Could not validate address', error);
            confirmedSignature = currentSignature;
            state.status = 'valid';
        }
    }

    function useAnyway(address) {
        if (controller) {
            controller.abort();
        }
        confirmedSignature = signature(address);
        state.status = 'valid';
        state.recommendations = [];
    }

    function applyRecommendation(address, recommendation) {
        Object.assign(address, {
            street: recommendation.street,
            houseNumber: recommendation.houseNo,
            zip: recommendation.zip,
            city: recommendation.city,
            countryCode: recommendation.country
        });

        return validate(address);
    }

    return {state, validate, useAnyway, applyRecommendation};
}
